// extracted by mini-css-extract-plugin
export default {"wrapper":"CardCollapsible_wrapper__3L7RA","nav":"CardCollapsible_nav__-SQx5","main":"CardCollapsible_main__ALvl2"};